import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLinkBroken = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "m15.75 10.25 1.257-1.257c.07-.07.105-.105.138-.14a4 4 0 0 0 1.104-2.665l.001-.195c0-.226 0-.338-.005-.434a4 4 0 0 0-3.805-3.804c-.095-.005-.207-.005-.433-.005l-.195.001a4 4 0 0 0-2.805 1.242L9.75 4.25m.5 11.5-1.257 1.257c-.07.07-.105.105-.14.138a4 4 0 0 1-2.665 1.104l-.195.001c-.226 0-.338 0-.434-.005a4 4 0 0 1-3.804-3.805c-.005-.095-.005-.207-.005-.433l.001-.195a4 4 0 0 1 1.104-2.665c.033-.035.068-.07.138-.14L4.25 9.75m3-7v4.5h-4.5m10 10v-4.5h4.5"
	})]
});
const ForwardRef = forwardRef(SvgLinkBroken);
export { ForwardRef as ReactComponent };
